export enum ServicePermissions {
  AuthorisationsPermission = 'PermissionSiteMgtAuthorisations',
  AuthorisationDetailsPermission = 'PermissionSiteMgtAuthorisationDetails',
  AuthorisationsExportPermission = 'PermissionSiteMgtAuthorisationsExport',
  CaseManagementPermission = 'PermissionSiteMgtCaseManagement',
  CaseManagementDetailsPermission = 'PermissionSiteMgtCaseManagementView',
  CaseManagementCreatePermission = 'PermissionSiteMgtCaseManagementCreate',
  CaseManagementResolvePermission = 'PermissionSiteMgtCaseManagementResolve',
  CaseManagementForwardPermission = 'PermissionSiteMgtCaseManagementForward',
  CaseManagementExportPermission = 'PermissionSiteMgtCaseManagementExport',
  CaseManagementEditPermission = 'PermissionSiteMgtCaseManagementEdit',
  ChargePointsPermission = 'PermissionSiteMgtChargePoint',
  ChargePointDetailsPermission = 'PermissionSiteMgtChargePointDetails',
  ChargePointsSoftResetPermission = 'PermissionSiteMgtChargePointSoftReset',
  ChargePointsHardResetPermission = 'PermissionSiteMgtChargePointHardReset',
  ChargePointsTriggerMessagePermission = 'PermissionSiteMgtChargePointTriggerMessage',
  ChargePointsReconnectPermission = 'PermissionSiteMgtChargePointReconnect',
  ChargePointsChangeAvailabilityPermission = 'PermissionSiteMgtChargePointChangeAvailability',
  ChargePointsClearCachePermission = 'PermissionSiteMgtChargePointClearCache',
  ChargePointsOutOfServicePermission = 'PermissionSiteMgtChargePointOutOfService',
  ChargePointsValidateCardPermission = 'PermissionSiteMgtChargePointValidateCard',
  ChargePointsStartSessionPermission = 'PermissionSiteMgtChargePointStartSession',
  ChargePointsConfigurationPermission = 'PermissionSiteMgtChargePointConfiguration',
  ChargePointsMessageLogsPermission = 'PermissionSiteMgtChargePointMessageLogs',
  ChargePointsActionLogsPermission = 'PermissionSiteMgtChargePointActionLogs',
  ChargePointsCertificatesPermission = 'PermissionSiteMgtChargePointCertificates',
  ChargePointsCertificatesInstallPermission = 'PermissionSiteMgtChargePointInstallCertificate',
  ChargePointsDiagnosticsPermission = 'PermissionSiteMgtChargePointDiagnostics',
  ChargePointsDiagnosticsDownloadPermission = 'PermissionSiteMgtChargePointDiagnosticsDownload',
  ChargePointsNfcLogsPermission = 'PermissionSiteMgtChargePointNfcLogs',
  ChargepointExportPermission = 'PermissionSiteMgtChargepointExport',
  ChargepointConfigurationExportPermission = 'PermissionSiteMgtChargepointConfigurationExport',
  ChargepointDeletePermission = 'PermissionSiteMgtChargepointDelete',
  DashboardPermission = 'PermissionSiteMgtDashboard',
  LocalControllerDetailsPermission = 'PermissionSiteMgtLCDetails',
  LCDetailsConfigurationEdit = 'PermissionSiteMgtLoadBalancingConfigurationEdit',
  LCDetailsConfigurationView = 'PermissionSiteMgtLoadBalancingConfigurationView',
  LocalControllerPermission = 'PermissionSiteMgtLocalController',
  ReportingPermission = 'PermissionSiteMgtReporting',
  LCAllegoPermission = 'PermissionSiteMgtLocalControllerAllego',
  LCGridXPermission = 'PermissionSiteMgtLocalControllerGridX',
  LCDownloadLogsPermission = 'PermissionSiteMgtLocalControllerDownloadLogs',
  LCRestartPermission = 'PermissionSiteMgtLocalControllerRestart',
  LogsPermission = 'PermissionSiteMgtLogsView',
  LoyaltyUsersPermission = 'PermissionSiteMgtLoyaltyUsers',
  LoyaltyUserDetailsPermission = 'PermissionSiteMgtLoyaltyUserDetails',
  PingLCPermission = 'PermissionSiteMgtPingLcr',
  UpdateLCPermission = 'PermissionSiteMgtUpdateLcr',
  SessionPermission = 'PermissionSiteMgtSession',
  SessionDetailsPermission = 'PermissionSiteMgtSessionDetails',
  SessionApprovePermission = 'PermissionSiteMgtSessionApprove',
  SessionRejectPermission = 'PermissionSiteMgtSessionReject',
  SessionInvalidatePermission = 'PermissionSiteMgtSessionInvalidate',
  SessionReratePermission = 'PermissionSiteMgtSessionRerate',
  SessionReAuthorizeReratePermission = 'PermissionSiteMgtSessionReAuthorizeRerate',
  SessionSendReceiptEmail = 'PermissionSiteMgtSessionSendReceiptEmail',
  SiteDetailsPermission = 'PermissionSiteMgtSiteDetails',
  SiteMonitoringPermission = 'PermissionSiteMgtSiteMonitoring',
  SiteMgtSiteExport = 'SiteMgtSiteExport',
  WorkOrderPermission = 'PermissionSiteMgtWorkOrder',
  WorkOrderDetailsPermission = 'PermissionSiteMgtWorkOrderView',
  WorkOrderExportPermission = 'PermissionSiteMgtWorkOrderExport',
  UserManagementPermission = 'PermissionSiteMgtUserManagement',
  UserManagementUsersPermission = 'PermissionSiteMgtUserManagementUsers',
  UserManagementUserDetailsPermission = 'PermissionSiteMgtUserManagementUserDetails',
  UserManagementUserAddPermission = 'PermissionSiteMgtUserManagementUserAdd',
  UserManagementUserEditPermission = 'PermissionSiteMgtUserManagementUserEdit',
  UserManagementUserDuplicatePermission = 'PermissionSiteMgtUserManagementUserDuplicate',
  UserManagementUserHardDeletePermission = 'PermissionSiteMgtUserManagementUserHardDelete',
  UserManagementUserInvitationPermission = 'PermissionSiteMgtUserManagementUserInvitation',
  UserManagementPermissionsPermission = 'PermissionSiteMgtUserManagementPermissions',
  UserManagementPermissionDetailsPermission = 'PermissionSiteMgtUserManagementPermissionDetails',
  UserManagementPermissionEditPermission = 'PermissionSiteMgtUserManagementPermissionEdit',
  UserManagementPermissionAddPermission = 'PermissionSiteMgtUserManagementPermissionAdd',
  UserManagementGroupsPermission = 'PermissionSiteMgtUserManagementGroups',
  UserManagementGroupDetailsPermission = 'PermissionSiteMgtUserManagementGroups',
  UserManagementRolesPermission = 'PermissionSiteMgtUserManagementRoles',
  UserManagementRoleDetailsPermission = 'PermissionSiteMgtUserManagementRoleDetails',
  UserManagementRoleAddPermission = 'PermissionSiteMgtUserManagementRolesAdd',
  UserManagementRoleEditPermission = 'PermissionSiteMgtUserManagementRolesEdit',
  UserManagementOrganisationDetailsPermission = 'PermissionSiteMgtUserManagementOrganisationDetails',
  UserManagementOrganisationsPermission = 'PermissionSiteMgtUserManagementOrganisations',
  FirmwarePermission = 'PermissionSiteMgtFirmware',
  FirmwarePermissionDetails = 'PermissionSiteMgtFirmwareDetails',
  FirmwareRegistrationEdit = 'PermissionSiteMgtFirmwareEdit',
  FirmwareRegistrationCreate = 'PermissionSiteMgtFirmwareCreate',
  FirmwarePermissionDownload = 'PermissionSiteMgtFirmwareDownload',
  FirmwareRCPermission = 'PermissionSiteMgtFirmwareReleaseCandidate',
  PIIViewPermission = 'PermissionSiteMgtPIIView',
  ServiceUserManagementRolesView = 'ServiceUserManagementRolesView',
  ServiceUserManagementPermissionsView = 'ServiceUserManagementPermissionsView',
  ServiceUserManagementUsersView = 'ServiceUserManagementUsersView',
  ServiceUserManagementGroupsView = 'ServiceUserManagementGroupsView',
  ServiceUserManagementOrganisationsView = 'ServiceUserManagementOrganisationsView'
}
